module.exports = __webpack_public_path__ + "static/media/ptc.367a5bf6.jpg";